var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1505 17.0446H8.21948V6.55201H12.1505V17.0446ZM8.62702 16.6347H11.7407V6.9596H8.62702V16.6347ZM12.2251 6.04659H8.14496V3.02808H12.2251V6.04659ZM8.5525 5.639H11.8152V3.438H8.5525V5.639Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.185 20.0002C4.67266 20.0002 0.184998 15.5144 0.184998 10.0014C0.184998 4.48842 4.67266 0.000244141 10.185 0.000244141C15.6973 0.000244141 20.185 4.48609 20.185 10.0014C20.185 15.5167 15.6997 20.0002 10.185 20.0002ZM10.185 0.407837C4.89622 0.407837 0.594871 4.70969 0.594871 9.99908C0.594871 15.2885 4.89622 19.5903 10.185 19.5903C15.4738 19.5903 19.7751 15.2885 19.7751 9.99908C19.7751 4.70969 15.4738 0.410166 10.185 0.410166",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ea5c1c5b5b6ca5dfef4c930b18360285.svg";
export { ForwardRef as ReactComponent };